import Vue from "vue";
import Vuetify from "vuetify/lib";
// Design system baseado no projeto de referência (cores/identidade)
import "@mdi/font/css/materialdesignicons.css";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    dark: true,
    themes: {
      dark: {
        primary: "#ff711a", // --primary (hsl 23 100% 55%)
        secondary: "#0f0f10", // dark card
        accent: "#00D1FF", // ciano
        background: "#0b0c0e", // base dark
        surface: "#141517", // surface/glass
        error: "#ff4d4f",
        info: "#4cc9f0",
        success: "#38d43a",
        warning: "#ff9900",
        footer: "#0b0c0e"
      },
      light: {
        primary: "#ff711a",
        secondary: "#f5f7fb",
        accent: "#00D1FF",
        error: "#ff4d4f",
        background: "#ffffff",
        footer: "#f5f7fb"
      }
    }
  },
  icons: { iconfont: "mdi" }
});
